module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "d-flex": "",
      "mb-3": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md2": "",
      "px-0": "",
      "text-xs-left": ""
    }
  }, [_c('select-date', {
    attrs: {
      "placeholder": "Inicio",
      "icon": "event"
    },
    model: {
      value: (_vm.initDate),
      callback: function($$v) {
        _vm.initDate = $$v
      },
      expression: "initDate"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md2": "",
      "px-0": "",
      "text-xs-left": ""
    }
  }, [_c('select-date', {
    attrs: {
      "placeholder": "Fin"
    },
    model: {
      value: (_vm.endDate),
      callback: function($$v) {
        _vm.endDate = $$v
      },
      expression: "endDate"
    }
  })], 1), _vm._v(" "), (_vm.numberDays) ? _c('span', [_vm._v("Total días: " + _vm._s(_vm.numberDays))]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "text-align-left": ""
    }
  }, [_c('select-button', {
    attrs: {
      "label-text": "Selecciona el hotel",
      "item-text": "name",
      "item-value": "id",
      "items": _vm.subsidiaries
    },
    model: {
      value: (_vm.subsidiaryId),
      callback: function($$v) {
        _vm.subsidiaryId = $$v
      },
      expression: "subsidiaryId"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "text-xs-left": ""
    }
  }, [_c('span', [_vm._v("Seleccione los Canales")]), _vm._v(" "), _c('div', [_c('v-checkbox', {
    staticClass: "block-checkbox",
    attrs: {
      "hide-details": "",
      "label": "Todos"
    },
    on: {
      "change": function($event) {
        _vm.selectAll('channels', _vm.channels, _vm.allChannels)
      }
    },
    model: {
      value: (_vm.allChannels),
      callback: function($$v) {
        _vm.allChannels = $$v
      },
      expression: "allChannels"
    }
  }), _vm._v(" "), _vm._l((_vm.channels), function(channel, indexChannel) {
    return _c('v-checkbox', {
      key: indexChannel,
      staticClass: "block-checkbox",
      attrs: {
        "hide-details": "",
        "label": channel.name
      },
      model: {
        value: (channel.checked),
        callback: function($$v) {
          channel.checked = $$v
        },
        expression: "channel.checked"
      }
    })
  })], 2)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "text-xs-left": ""
    }
  }, [_c('span', [_vm._v("Seleccione los tipos de habitación")]), _vm._v(" "), _c('div', [_c('v-checkbox', {
    staticClass: "block-checkbox",
    attrs: {
      "hide-details": "",
      "label": "Todos"
    },
    on: {
      "change": function($event) {
        _vm.selectAll('roomTypes', _vm.roomTypes, _vm.allRoomTypes)
      }
    },
    model: {
      value: (_vm.allRoomTypes),
      callback: function($$v) {
        _vm.allRoomTypes = $$v
      },
      expression: "allRoomTypes"
    }
  }), _vm._v(" "), _vm._l((_vm.roomTypes), function(roomType, indexRoomType) {
    return _c('v-checkbox', {
      key: indexRoomType,
      staticClass: "block-checkbox",
      attrs: {
        "hide-details": "",
        "label": roomType.name
      },
      model: {
        value: (roomType.checked),
        callback: function($$v) {
          roomType.checked = $$v
        },
        expression: "roomType.checked"
      }
    })
  })], 2)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": "",
      "mt-5": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-save btn-save-form mt-3",
    attrs: {
      "type": "button",
      "disabled": !_vm.validations
    },
    on: {
      "click": _vm.saveBlocking
    }
  }, [_vm._v("\n\t\t\tGuardar\n\t\t")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f19e01e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/clerkinn/blocking/blocking.vue
// module id = 1582
// module chunks = 27